import type { SVGProps } from "react"
import React from "react"

export const Filter: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 16,
  height = 16,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <title>Filter Icon</title>
    <path
      d="M2.25977 1.25H14.2598C14.4587 1.25 14.6494 1.32902 14.7901 1.46967C14.9307 1.61032 15.0098 1.80109 15.0098 2V3.1895C15.0097 3.3884 14.9307 3.57913 14.79 3.71975L9.97877 8.53025C9.83838 8.67099 9.75961 8.86171 9.75977 9.0605V13.7892C9.75976 13.9033 9.73377 14.0158 9.68376 14.1182C9.63376 14.2207 9.56105 14.3104 9.47118 14.3805C9.3813 14.4506 9.27662 14.4994 9.16508 14.523C9.05355 14.5466 8.9381 14.5445 8.82752 14.5167L7.32752 14.1417C7.16533 14.1011 7.02137 14.0075 6.91851 13.8757C6.81564 13.7438 6.75977 13.5814 6.75977 13.4142V9.0605C6.75972 8.8616 6.68068 8.67087 6.54002 8.53025L1.72877 3.71975C1.58838 3.57901 1.50961 3.38829 1.50977 3.1895V2C1.50977 1.80109 1.58878 1.61032 1.72944 1.46967C1.87009 1.32902 2.06085 1.25 2.25977 1.25Z"
      stroke="#1D1D1B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
